import Calculator from '@/components/Calculator';
import { CalculatorData } from '@/services/cms/types';
import {
  getMonthlyPaymentFieldConfig,
  getMonthlyPaymentOutputConfig,
  MonthlyPaymentInputSchema,
  MonthlyPaymentSectionConfig,
  MonthlyPaymentKeys
} from '@/services/calculators/schemas/monthlyPayment';
import {
  DSCRInputSchema,
  DSCRSectionConfig,
  getDSCRFieldConfig,
  getDSCROutputConfig,
  DSCRKeys
} from '@/services/calculators/schemas/dscr';
import {
  CashToCloseInputSchema,
  CashToCloseSectionConfig,
  getCashToCloseFieldConfig,
  getCashToCloseOutputConfig,
  CashToCloseKeys
} from '@/services/calculators/schemas/cashToClose';

type CalculatorType = NonNullable<
  NonNullable<
    CalculatorData['calculators'][number]['calculator']
  >['calculator_type']
>;

export default function CalculatorBySlug({
  type
}: {
  type?: CalculatorType | null;
}) {
  switch (type) {
    case 'monthly_payment':
      return (
        <Calculator
          schema={MonthlyPaymentInputSchema}
          sectionConfig={MonthlyPaymentSectionConfig}
          getFieldConfig={getMonthlyPaymentFieldConfig}
          getOutput={getMonthlyPaymentOutputConfig}
          keys={MonthlyPaymentKeys}
        />
      );
    case 'dscr':
      return (
        <Calculator
          schema={DSCRInputSchema}
          sectionConfig={DSCRSectionConfig}
          getFieldConfig={getDSCRFieldConfig}
          getOutput={getDSCROutputConfig}
          keys={DSCRKeys}
        />
      );
    case 'cash_to_close':
      return (
        <Calculator
          schema={CashToCloseInputSchema}
          sectionConfig={CashToCloseSectionConfig}
          getFieldConfig={getCashToCloseFieldConfig}
          getOutput={getCashToCloseOutputConfig}
          keys={CashToCloseKeys}
        />
      );
    default:
      return <div>Calculator not implemented</div>;
  }
}
